//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "ListTagsWithNumberingBlock",

  computed: {
    getStyleTags: function () {
      let _list = new Array(Math.ceil((this.values.items || []).length / 2)).fill('1fr');
      return `grid-template-rows: ${_list.join(' ')}`
    }
  }
});
